<template>
  <DxTabPanel
    :element-attr="tabPanelAttributes"
    :data-source="fieldReportSteps"
    :loop="false"
    :selected-item="currentItem"
    :selected-index="currentStep"
    :animation-enabled="true"
    :swipe-enabled="false"
    :show-nav-buttons="false"
    @selection-changed="tabSelectionChanged($event)"
  >
    <template #item="{ data: step }">
      <div>
        <div v-if="step == 1" :use-native="true">
          <DxScrollView ref="receptionInputScroll" v-show="step == 1" class="reception-input-scroll" :use-native="true">
            <div class="reception_input_holder" :class="[{ input_holder_error: $v.fieldReportData.field_report_date.$error }]">
              <div @click="showCalendarSelector">
                <div class="input_label">Data</div>
                <div class="input_value date_input_value">
                  <span>{{ fieldReportData.field_report_date }}</span>
                </div>
              </div>
              <div v-if="is_date_selector_visible">
                <FunctionalCalendar
                  :date-format="getDefaultDateFormat.toLowerCase()"
                  :is-date-range="false"
                  v-model="calendarData"
                  :change-month-function="true"
                  :change-year-function="true"
                  :is-date-picker="true"
                  :is-disabled="false"
                  @choseDay="calendarDayChosen"
                  @input="onDateSelected"
                ></FunctionalCalendar>
              </div>
            </div>
            <div class="reception_input_holder"
             @click="contractsClick()">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">Nr. Contract</div>
                  <div v-if="fieldReportData.contract_number" class="input_value">
                    {{ fieldReportData.contract_number }}
                  </div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">Alegeți contract</div>
                  <div class="reception_input_second_value" v-if="selectedContracts.length > 0">
                    {{ getSelectedContractInfo }}
                  </div>
                </div>
                <div class="reception_contract_actions">
                  <div
                    v-if="selectedContracts.length > 0"
                    class="reception_parcel_edit_icon reception_contract_remove_icon"
                    @click.stop="clearContract"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </div>
                  <div class="reception_parcel_edit_icon">
                    <i class="fa-regular fa-edit"></i>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="reception_input_holder"
              @click="showProductSelector()"
              :class="[{ input_holder_error: $v.fieldReportData.products.$error }]"
            >
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info">
                  <div class="input_label">Produs</div>
                  <div v-if="fieldReportData.products.length > 0" class="input_value">
                    {{ getSelectedProduse() }}
                  </div>
                  <div v-else class="input_value_placeholder" style="color: #989696 !important">Alegeți produs</div>
                  <div class="reception_input_second_value">
                    {{
                      fieldReportData.products.length > 0
                        ? fieldReportData.products[0].quantity + " " + fieldReportData.products[0]?.measure_unit?.symbol
                        : ""
                    }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info" @click="parcelsClick()">
                  <div class="input_label">Parcele</div>
                  <div class="input_value">{{ getParcelNames }}</div>
                  <div class="reception_input_second_value">
                    {{ getSelectedParcelCountForInput }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon" @click="parcelsClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder" v-if="false">
              <div class="reception_parcel_select_edit">
                <div class="reception_parcel_info" @click="warehouseClick()">
                  <div class="input_label">Depozit</div>
                  <div class="input_value">{{ getWareHouseNames }}</div>
                  <div class="reception_input_second_value">
                    {{ getSelectedWarehousesCount }}
                  </div>
                </div>
                <div class="reception_parcel_edit_icon" @click="warehouseClick()">
                  <i class="fa-regular fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="input_label">Locul încărcării</div>
              <div class="input_value">
                <DxAutocomplete
                  v-model="fieldReportData.uploading_place"
                  :data-source="uploadPlaceHistory"
                  placeholder="Introduceți locul încărcării"
                  class="global_dx_textbox"
                  :min-search-length="0"
                  :show-clear-button="true"
                />
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="input_label">Locul descărcării</div>
              <div class="input_value">
                <DxAutocomplete
                  v-model="fieldReportData.unloading_place"
                  :data-source="unloadingPlaceHistory"
                  placeholder="Introduceți locul descărcării"
                  class="global_dx_textbox"
                  :min-search-length="0"
                  :show-clear-button="true"
                />
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="input_label">Nr. de înmat. al utilajului de tractare</div>
              <div class="input_value">
                <DxAutocomplete
                  v-model="fieldReportData.tractor_number_plate"
                  :data-source="tractorNumberPlateHistory"
                  placeholder="Introduceți numărul de înmatriculare al vehiculului"
                  class="global_dx_textbox"
                  :min-search-length="0"
                  :show-clear-button="true"
                />
              </div>
            </div>
            <div class="reception_input_holder">
              <div class="input_label">Șofer</div>
              <div class="input_value">
                <DxAutocomplete
                  v-model="fieldReportData.driver_name"
                  :data-source="driverNameHistory"
                  placeholder="Introduceți numele delegatului"
                  class="global_dx_textbox"
                  :min-search-length="0"
                  :show-clear-button="true"
                  @value-changed="onDriverNameSelected"
                />
              </div>
            </div>
            <div class="row-flex">
              <div class="reception_input_holder lg input_serie">
                <div class="input_label">Serie</div>
                <div class="input_value">
                  <DxAutocomplete
                    v-model="fieldReportData.driver_serial_identifier"
                    :data-source="driverSerialIdentifierHistory"
                    placeholder="Introduceți seria"
                    class="global_dx_textbox"
                    :min-search-length="0"
                    :show-clear-button="true"
                    @input="onSeriesInput"
                  />
                </div>
              </div>
              <div class="reception_input_holder input_number">
                <div class="input_label">Număr</div>
                <div class="input_value">
                  <DxAutocomplete
                    v-model="fieldReportData.driver_number_identifier"
                    :data-source="driverNumberIdentifierHistory"
                    placeholder="Introduceți numărul"
                    class="global_dx_textbox"
                    :min-search-length="0"
                    :show-clear-button="true"
                    @input="onNumberInput"
                  />
                </div>
              </div>
            </div>
            <div class="input-bottom-spacer"></div>
          </DxScrollView>
        </div>
        <div v-show="step == 2" class="reception_step_map">
          <div v-if="showParcelSelectionOptions" class="step_1" width="100%">
            <div class="step_1_container">
              <div class="step_title">{{ $t("stock_management.consum.options.parcel") }}</div>
              <div
                v-for="option in parcelSelectionOptions"
                :key="option.code"
                :class="['article_item', 'article_item_selected']"
                @click="selectParcelSelectionOption(option)"
              >
                {{ $t(option.titleKey) }}
              </div>
            </div>
          </div>
          <template v-else>
            <google-map
              v-if="parcelViewMode === 'map'"
              ref="googlemap"
              :showMap="step == 2"
              :selection_mode="true"
              :season_uuid="season_uuid_local"
              :initMapInMount="true"
              mapClass="reception_map"
              :selected-parcel-uuids="selectedParcelUuids"
              :sync-selection-from-props="true"
              @showToastMessage="showToastMessage"
              @removeSelectedParcel="removeSelectedParcel"
              @addSelectedParcel="addSelectedParcel"
            ></google-map>
            <div v-else class="field_report_parcel_list">
              <ParcelListSelector
                :seasons="seasons"
                :selected-layer-uuids="selectedParcelUuids"
                :default-season-uuid="season_uuid_local"
                :show-toggle="true"
                @toggle-layer="toggleLayerFromList"
                @toggle-view="setParcelViewMode('map')"
                @season-change="onSeasonChange"
                @reset-selection="resetSelectedParcels"
              />
            </div>
          </template>
        </div>
        <div v-if="step == 6" class="reception_step_map">
          <ContractsPurchaseSaleSelector
            v-if="step == 6"
            :multiselect="false"
            :selectedContracts.sync="selectedContracts"
            :filterData="{
              contract_type_id: '2, 3',
              product_measure_unit_group_id: 2, // 2 = weight
              show_completed_rows: 0,
              //sale_type: 'partner',
            }"
          />
        </div>
        <div
          class="reception_bottom_sticky"
          v-show="
            (step == 2 && selectedLayers.length > 0) ||
            (step == 6 && selectedContracts.length > 0)
          "
        >
          <div class="sticky_action_button" @click="continueFromSelection">Continuă</div>
        </div>
        <div class="bottom_sticky_two_line" v-show="step == 1 && showSaveButtons && !saveButtonPressed">
          <div style="display: flex; flex-direction: row; width: 100%">
            <div class="sticky_action_button" style="margin-right: 6px" @click="saveFieldReport(true)">Salvează și nouă</div>
          </div>
          <div class="sticky_action_button_second" @click="saveFieldReport(false)">Salvează</div>
        </div>
        <ProductSelector
          ref="productSelector"
          :showPopup="productSelectorVisibility"
          @hidden="hideProductSelector"
          :selectedProducts="fieldReportData.products"
          :multipleSelection="false"
          :filterData="{
            measure_unit_group_id: 2, // 2 = weight
          }"
          :useUnitPrice="false"
          :isProductEditable="selectedContracts.length > 0 ? false : true"
          :transactionType="transactionTypeTitle"
          :requiredLotForLotManagedProducts="false"
        >
        </ProductSelector>
        <LotNumberResolvePopup
          v-model="lotResolvePopup.visible"
          :title="lotResolvePopup.title"
          :message="lotResolvePopup.message"
          :mode="lotResolvePopup.mode"
          :lot-options="lotResolvePopup.options"
          :input-placeholder="lotResolvePopup.inputPlaceholder"
          :confirm-text="lotResolvePopup.confirmText"
          :continue-without-lot-text="lotResolvePopup.continueWithoutLotText"
          :cancel-process-text="lotResolvePopup.cancelProcessText"
          @resolved="onLotResolvePopupResolved"
        />
        <toast-message ref="toastMessage"></toast-message>
      </div>
    </template>
  </DxTabPanel>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTabPanel from "devextreme-vue/tab-panel";
import { required } from "vuelidate/src/validators";
import DxTextBox from "devextreme-vue/text-box";
import DxComboWithAdd from "@/components/Mobile/DxComboWithAdd/index.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxSelectBox from "devextreme-vue/select-box";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import DxTextArea from "devextreme-vue/text-area";
import { FunctionalCalendar } from "vue-functional-calendar";
import moment from "moment";
import ProductSelector from "../../../stock-mobile/dialogs/Product/ProductSelector.vue";
import GoogleMap from "@/components/Map/GoogleMap.vue";
import ContractsPurchaseSaleSelector from "@/components/Mobile/ContractsPurchaseSaleSelector.vue";
import LotNumberResolvePopup from "@/components/Common/LotNumberResolvePopup.vue";
import ParcelListSelector from "@/pages/stock-mobile/partials/ParcelListSelector.vue";
import DxAutocomplete from "devextreme-vue/autocomplete";
import { ParcelSelectionOptions } from "../../../stock-mobile/dialogs/partials/consum.js";
import { TransactionActions, TransactionOptions } from "../../../stock-mobile/dialogs/transactions.js";
import {
  roundToDecimals,
  divideWeightByParcels,
  extractProductFromWeighingProducts,
  extractParcelsFromRecord,
  extractRecipientWarehouseUuidsFromWeighingProducts,
  buildWeighingProductsByWarehouseGroups,
} from "@/helpers/weighingOnScaleHelper";

export default {
  name: "FieldReport",
  props: {
    selectedFieldReportUuid: {
      type: String,
      default: "",
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      preselectDate: true,
      calendarData: {},
      fieldReportSteps: [1, 2, 6],
      currentStep: 0,
      currentItem: 1,
      tabPanelAttributes: {
        class: "reception_tabs",
      },
      fieldReportData: {
        products: [],
        field_report_date: null,
        unloading_place: "",
        uploading_place: "",
        contract_number: "",
        tractor_number_plate: "",
        driver_name: "",
        driver_serial_identifier: "",
        driver_number_identifier: "",
        custody: false, // Custodie
      },
      is_date_selector_visible: false,
      productSelectorVisibility: false,
      saveButtonPressed: false,
      selectedLayers: [],
      season_uuid_local: "",
      currentSeason: {},
      selectedPartners: [],
      selectedContracts: [],
      is_department_splited: false,
      layerDepartmentMap: [],
      unloadingPlaceHistory: [],
      uploadPlaceHistory: [],
      driverSerialIdentifierHistory: [],
      driverNumberIdentifierHistory: [],
      driverNameHistory: [],
      tractorNumberPlateHistory: [],
      driverIdentifierRelation: [],
      loadingExistingReport: false,
      lotResolvePopup: {
        visible: false,
        title: "",
        message: "",
        mode: "select",
        options: [],
        inputPlaceholder: "",
        confirmText: "",
        continueWithoutLotText: "",
        cancelProcessText: "",
      },
      lotResolveResolver: null,
      selectedParcelSourceOption: null,
      parcelViewMode: "map",
    };
  },
  components: {
    DxTabPanel,
    DxTextBox,
    DxComboWithAdd,
    DxScrollView,
    DxSelectBox,
    ToastMessage,
    DxTextArea,
    FunctionalCalendar,
    ProductSelector,
    LotNumberResolvePopup,
    GoogleMap,
    ParcelListSelector,
    DxAutocomplete,
    ContractsPurchaseSaleSelector,
  },
  computed: {
    ...mapGetters({
      seasons: "seasons/seasons",
      getDefaultDateFormat: "settings/getDefaultDateFormat",
      departments: "company/departments",
    }),
    transactionTypeTitle() {
      return TransactionOptions.find((opt) => opt.code === TransactionActions.Production)?.title || "";
    },
    showSaveButtons() {
      return (
        this.fieldReportData.products.length > 0 &&
        this.selectedLayers.length > 0 &&
        this.fieldReportData.field_report_date &&
        //this.selectedDepartments.length > 0 &&
        this.fieldReportData.unloading_place != "" &&
        this.fieldReportData.uploading_place != "" &&
        this.fieldReportData.tractor_number_plate != "" &&
        this.fieldReportData.driver_name != "" &&
        this.fieldReportData.driver_serial_identifier != "" &&
        this.fieldReportData.driver_number_identifier != ""
      );
    },
    getSelectedParcelSurfaceDecimal() {
      return this.selectedLayers && this.selectedLayers.length > 0
        ? this.selectedLayers
            .map((l) => l.surface)
            .reduce((x, y) => {
              return (parseFloat(x) + parseFloat(y)).toFixed(2);
            })
        : 0;
    },
    getSelectedParcelSurface() {
      return "Ai selectat " + this.getSelectedParcelSurfaceDecimal + " hectare cu ";
    },
    getSelectedParcelCount() {
      return "" + this.selectedLayers.length + (this.selectedLayers.length == 1 ? " parcelă" : " parcele");
    },
    getParcelNames() {
      return this.selectedLayers.map((l) => l.name).join(", ");
    },
    getSelectedParcelCountForInput() {
      return (
        "" +
        this.selectedLayers.length +
        (this.selectedLayers.length == 1 ? " parcelă selectată" : " parcele selecatte") +
        " (" +
        this.getSelectedParcelSurfaceDecimal +
        " ha)"
      );
    },
    getSelectedContractInfo() {
      if (this.selectedContracts.length > 0) {
        const contract = this.selectedContracts[0];
        return contract.partner_name + " / " + this.getContractTypeLabel(contract.contract_type_id);
      }
      return "";
    },
    parcelSelectionOptions() {
      return ParcelSelectionOptions;
    },
    showParcelSelectionOptions() {
      return this.selectedParcelSourceOption == null;
    },
    selectedParcelUuids() {
      return [...new Set(this.selectedLayers.map((layer) => layer?.uuid || layer?.parcel_uuid).filter(Boolean))];
    },
  },
  validations() {
    return {
      fieldReportData: {
        field_report_date: { required },
        products: { required },
        unloading_place: { required },
        uploading_place: { required },
        tractor_number_plate: { required },
        driver_name: { required },
        driver_serial_identifier: { required },
        driver_number_identifier: { required },
      },
    };
  },
  methods: {
    ...mapActions({
      createWeighingOnScale: "scale/createWeighingOnScale",
      updateWeighingOnScale: "scale/updateWeighingOnScale",
      getWeighingOnScaleByUuid: "scale/getWeighingOnScaleByUuid",
      getSeasons: "seasons/getSeasons",
      getDepartments: "company/getDepartments",
      getWeighingOnScaleAutocompleteData: "scale/getWeighingOnScaleAutocompleteData",
      getPartnerData: "smPartners/getSmPartner",
      getProduct: "smProducts/getSmProduct",
      getPredefinedLotNumbers: "smPredefinedLotNumbers/getPredefinedLotNumbers",
    }),
    tabSelectionChanged(e) {
      this.currentItem = e.addedItems[0];
      this.currentStep = this.fieldReportSteps.indexOf(this.currentItem);
      this.changeAddButtonVisibility();
    },
    removeSelectedParcel(layer) {
      const index = this.selectedLayers.findIndex((l) => l.uuid === layer.uuid);
      if (index > -1) {
        this.selectedLayers.splice(index, 1);
      }
      this.setTitle();
    },
    addSelectedParcel(layer) {
      // Only allow adding the layer if its department_uuid matches one
      // layer.department_legal_entity_uuid - exist

      // If a contract is selected, check legal_entity_uuid match
      if (this.selectedContracts.length > 0 && layer.department_legal_entity_uuid !== this.selectedContracts[0].legal_entity_uuid) {
        this.showToastMessage(
          "error",
          "Nu poți adăuga parcela " + layer.name + " deoarece nu are aceeași societate cu contractul selectat!",
        );
        this.$refs.googlemap.parcelClick(null, layer);
        return;
      }

      /*if (this.selectedLayers.length > 0 && !this.selectedLayers.some((s_layer) => s_layer.department_uuid === layer.department_uuid)) {
        this.showToastMessage(
          "error",
          "Nu poți adăuga parcela " + layer.name + " deoarece nu are aceeași societate cu celelalte parcele selectate!",
        );
        this.$refs.googlemap.parcelClick(null, layer);
        return;
      }*/

      layer.surface = Number.parseFloat(layer.surface);
      if (!this.selectedLayers.some((l) => l.uuid === layer.uuid)) {
        this.selectedLayers.push({ ...layer });
      }

      this.setTitle();
    },
    parcelsClick() {
      this.currentStep = 1;
      this.selectedParcelSourceOption = null;
      this.setTitle();
    },
    contractsClick() {
      this.currentStep = 2;
      this.setTitle();
    },
    selectParcelSelectionOption(option) {
      if (!option || !option.code) {
        return;
      }
      this.selectedParcelSourceOption = option.code;
      this.setParcelViewMode(option.code);
    },
    setParcelViewMode(mode) {
      this.parcelViewMode = mode === "list" ? "list" : "map";
    },
    toggleLayerFromList(layer) {
      if (!layer || !layer.uuid) {
        return;
      }
      if (this.selectedLayers.some((l) => (l?.uuid || l?.parcel_uuid) === layer.uuid)) {
        this.removeSelectedParcel(layer);
      } else {
        this.addSelectedParcel(layer);
      }
    },
    resetSelectedParcels() {
      if (this.selectedLayers.length === 0) {
        return;
      }
      this.selectedLayers = [];
      this.setTitle();
    },
    onSeasonChange(seasonUuid) {
      const nextSeasonUuid = seasonUuid || this.currentSeason?.uuid || "";
      this.season_uuid_local = nextSeasonUuid;
    },
    showToastMessage(type, message) {
      this.$refs.toastMessage.showToastMessage(type, message);
    },
    goBack() {
      if (this.currentStep > 0) {
        this.currentStep = 0;
        this.setTitle();
      } else {
        this.$emit("goBackParent");
      }
    },
    setTitle() {
      if (this.currentStep == 0) {
        this.$emit("setTitle", this.$t("common.field_report"), true);
      } else if (this.currentStep == 1) {
        this.$emit("setTitle", this.$t("common.field_report"), true, this.getSelectedParcelSurface, this.getSelectedParcelCount);
      } else if (this.currentStep == 2) {
        this.$emit("setTitle", "Contracte", true);
      }
    },
    changeAddButtonVisibility() {
      this.$emit("changeAddButtonVisibility", false);
    },
    getContractTypeLabel(contractTypeId) {
      if (parseInt(contractTypeId) === 1) {
        return this.$t("stock_management.contracts_purchase_sale.contract_type_purchase");
      }

      if (parseInt(contractTypeId) === 2) {
        return this.$t("stock_management.contracts_purchase_sale.contract_type_sale");
      }

      if (parseInt(contractTypeId) === 3) {
        return this.$t("stock_management.contracts_purchase_sale.contract_type_custody");
      }

      return "-";
    },
    getSelectedProduse() {
      if (this.fieldReportData.products.length > 0) {
        if (this.fieldReportData.products.length === 1) {
          return this.fieldReportData.products[0].name;
        } else if (this.fieldReportData.products.length > 1) {
          return this.fieldReportData.products[0].name + ", " + this.fieldReportData.products[1].name;
        }
      } else {
        return null;
      }
    },
    async saveFieldReport(saveAndNew) {
      if (this.selectedLayers.length == 0) {
        this.$refs.toastMessage.showError(["Parcela este obligatoriu!"]);
        return;
      }

      if (this.fieldReportData.products.length == 0) {
        this.$refs.toastMessage.showError(["Produsul este obligatoriu!"]);
        return;
      }

      let errorMessages = [];
      this.fieldReportData.products.forEach((product, index) => {
        if (!product.measure_unit_id) {
          errorMessages.push(`Unitatea de măsură este obligatorie (${product.name})!`);
        }
        if (!product.product_type_uuid) {
          errorMessages.push(`Tipul de produs este obligatoriu (${product.name})!`);
        }
        if ((product.quantity ?? 0) <= 0) {
          errorMessages.push(`Cantitatea ${product.name} trebuie să fie mai mare de 0!`);
        }
      });

      if (errorMessages.length > 0) {
        this.$refs.toastMessage.showError(errorMessages);
        return;
      }

      this.saveButtonPressed = true;

      this.$v.fieldReportData.$touch();
      if (!this.$v.fieldReportData.$invalid) {
        const product = this.fieldReportData.products.length > 0 ? this.fieldReportData.products[0] : null; // just one product for field report

        if (product.uuid.startsWith("NEW_")) {
          product.uuid = "";
        }

        const product_quantity = product?.quantity ?? 0;
        let product_quantity_kg = 0;
        // Convert product quantity to kg if the measure unit is kg or if it has a conversion factor for kg
        // If the product has a measure unit with symbol "kg", we use that directly
        if (product?.measure_unit?.symbol == "kg") {
          product_quantity_kg = product_quantity;
        } else if (product && Array.isArray(product.valid_measureunits_for_product)) {
          const kgUnit = product.valid_measureunits_for_product.find((u) => u.target_measure_unit == "kg");
          if (kgUnit && kgUnit.conversion_factor) {
            product_quantity_kg = product_quantity * kgUnit.conversion_factor;
          }
        }

        if (product_quantity_kg <= 0) {
          this.$refs.toastMessage.showError("Cantitatea produsului(kg) trebuie să fie mai mare de 0!");
          this.saveButtonPressed = false;
          return;
        }

        // If a contract is selected, we take the department from the contract, otherwise we take it from the selected layers (the one with the biggest surface)
        const max_layer_surface_department_uuid = this.selectedLayers.reduce((max, layer) => {
          if (!max || layer.surface > max.surface) {
            return layer;
          }
          return max;
        }, null)?.department_uuid;
        const department = this.departments.find((d) => d.uuid === max_layer_surface_department_uuid);
        const department_name = department.parent_legal_entity?.name ?? department.legal_entity?.name ?? department.name ?? "";
        const department_legal_entity_adress = department.parent_legal_entity?.address ?? department.legal_entity?.address ?? "";

        let partner = null;
        let partner_address = null;
        if (this.selectedPartners.length > 0) {
          partner = this.selectedPartners[0];
          partner_address = partner?.locality?.DENUMIRE ?? "";
          if (partner_address && partner?.street_and_number) {
            partner_address += ", ";
          }
          partner_address += partner?.street_and_number ?? "";
        }

        const selectedContract = this.selectedContracts.length > 0 ? this.selectedContracts[0] : null;
        const fieldReportType = selectedContract && selectedContract.contract_type_id == 3 ? 1 : this.selectedContracts.length > 0 ? 2 : 1;

        let fieldReportForSave = {
          ...this.fieldReportData,
          // scale_house_uuid: null,
          field_report: true,
          create_inventory_movement: false,
          date: this.fieldReportData.field_report_date.split(" ")[0],
          datetime: this.fieldReportData.field_report_date,
          weighing_type_id: 6, // 6 = recolta
          field_report_type: fieldReportType, // 1 = standard field report, 2 = field report with contract
          // vehicle_configuration: null,
          estimated_weight_kg: product_quantity_kg,
          netto_weight_kg: 0,
          empty_weight_kg: this.fieldReportData?.empty_weight_kg ?? 0,
          full_weight_kg: 0,
          partner_uuid: partner?.uuid ?? null,
          partner_name: partner?.name ?? department_name ?? "",
          partner_address: partner_address ?? department_legal_entity_adress,
          buyer_seller_uuid: department.uuid ?? null,
          buyer_seller_name: department_name,
          buyer_seller_address: department_legal_entity_adress,
          unloading_place: this.fieldReportData.unloading_place,
          uploading_place: this.fieldReportData.uploading_place,
          contract_number: this.fieldReportData.contract_number,
          tractor_number_plate: this.fieldReportData.tractor_number_plate,
          driver_name: this.fieldReportData.driver_name,
          driver_serial_identifier: this.fieldReportData.driver_serial_identifier,
          driver_number_identifier: this.fieldReportData.driver_number_identifier,
          custody: this.fieldReportData.custody,
          notes: product?.notes ?? "",
          measurements: [],
          weighing_products: [],
          contract_uuid: this.selectedContracts.length > 0 ? this.selectedContracts[0].uuid : null,
          field_report_mobile: true, // flag to identify field reports created from mobile
        };

        fieldReportForSave.weighing_products = this.calculateWeighingProducts(product_quantity_kg, product);
        this.mergeExistingLotNumbersFromLoadedReport(fieldReportForSave);
        const canContinueSave = await this.resolveFieldReportLotNumberBeforeSave(fieldReportForSave, product);
        if (canContinueSave === false) {
          this.saveButtonPressed = false;
          return;
        }

        const saveAction = this.isEditMode ? this.updateWeighingOnScale : this.createWeighingOnScale;
        if (this.isEditMode) {
          fieldReportForSave.uuid = this.fieldReportData.uuid || this.selectedFieldReportUuid || null;
        }

        saveAction(fieldReportForSave)
          .then((response) => {
            if (!this.isEditMode && saveAndNew && !!response?.data?.uuid) {
              this.$refs.toastMessage.showSuccess("Recepția a fost salvată cu succes!");
              this.resetForm();
              this.saveButtonPressed = false;
            } else {
              this.closeTransactions("Recepția a fost salvată cu succes!");
            }
          })
          .catch((e) => {
            this.saveButtonPressed = false;
            console.log("field_report error ", e);
            var errorMessage = e.response?.data?.message || "A apărut o eroare la salvare. Contactați administratorul de sistem!";
            this.$refs.toastMessage.showError(errorMessage);
          });
      } else {
        this.$refs.toastMessage.showError(this.createErrormMssages());
        this.saveButtonPressed = false;
      }
    },
    mergeExistingLotNumbersFromLoadedReport(fieldReportForSave) {
      if (!Array.isArray(fieldReportForSave?.weighing_products) || !Array.isArray(this.fieldReportData?.weighing_products)) {
        return;
      }

      const lotMapByProductParcel = {};
      const fallbackLotByProduct = {};

      this.fieldReportData.weighing_products.forEach((item) => {
        const lotNumber = (item?.lot_number || "").trim();
        if (!lotNumber) {
          return;
        }

        const productUuid = item?.product_uuid || "";
        const parcelUuid = item?.parcel_uuid || "";
        if (productUuid && parcelUuid) {
          lotMapByProductParcel[`${productUuid}|${parcelUuid}`] = lotNumber;
        }
        if (productUuid && !fallbackLotByProduct[productUuid]) {
          fallbackLotByProduct[productUuid] = lotNumber;
        }
      });

      fieldReportForSave.weighing_products = fieldReportForSave.weighing_products.map((item) => {
        const existingLot = (item?.lot_number || "").trim();
        if (existingLot) {
          return item;
        }

        const productUuid = item?.product_uuid || "";
        const parcelUuid = item?.parcel_uuid || "";
        const mappedLot = lotMapByProductParcel[`${productUuid}|${parcelUuid}`] || fallbackLotByProduct[productUuid] || "";

        return mappedLot ? { ...item, lot_number: mappedLot } : item;
      });
    },
    async resolveFieldReportLotNumberBeforeSave(fieldReportForSave, selectedProduct) {
      const weighingProducts = Array.isArray(fieldReportForSave?.weighing_products) ? fieldReportForSave.weighing_products : [];
      if (!weighingProducts.length) {
        return true;
      }

      if (weighingProducts.some((item) => !!(item?.lot_number || "").trim())) {
        return true;
      }

      const productUuid = selectedProduct?.uuid || weighingProducts[0]?.product_uuid;
      if (!productUuid) {
        return true;
      }

      const productData = selectedProduct?.lot_management !== undefined
        ? selectedProduct
        : await this.getProduct({ uuid: productUuid });

      if (!productData?.lot_management) {
        return true;
      }

      const parcelUuids = [...new Set(weighingProducts.map((item) => item?.parcel_uuid).filter((uuid) => !!uuid))];
      if (!parcelUuids.length) {
        return true;
      }

      const predefinedResponse = await this.getPredefinedLotNumbers({
        page: 1,
        limit: 1000,
        product_uuid: productUuid,
        parcel_uuids: parcelUuids.join(","),
      });

      const predefinedRows = predefinedResponse?.data?.data || [];
      const lotNumbers = [...new Set(predefinedRows.map((row) => (row?.lot_number || "").trim()).filter((value) => !!value))];

      let selectedLotNumber = "";
      let popupAction = "continue_without_lot";

      if (lotNumbers.length === 1) {
        selectedLotNumber = lotNumbers[0];
      } else if (lotNumbers.length > 1) {
        const popupResult = await this.openLotResolvePopup({
          title: this.$t("stock_management.predefined_lot_numbers.title"),
          message: this.$t("stock_management.products.lot_management"),
          mode: "select",
          options: lotNumbers,
        });
        popupAction = popupResult?.action || "continue_without_lot";
        selectedLotNumber = (popupResult?.value || "").trim();
      } else {
        const popupResult = await this.openLotResolvePopup({
          title: this.$t("lot_items.please_insert_lot_number"),
          message: this.$t("stock_management.predefined_lot_numbers.lot_number"),
          mode: "input",
          inputPlaceholder: this.$t("stock_management.predefined_lot_numbers.lot_number"),
        });
        popupAction = popupResult?.action || "continue_without_lot";
        selectedLotNumber = (popupResult?.value || "").trim();
      }

      if (popupAction === "cancel_save") {
        return false;
      }

      if (!selectedLotNumber) {
        return true;
      }

      fieldReportForSave.weighing_products = weighingProducts.map((item) => ({
        ...item,
        lot_number: selectedLotNumber,
      }));
      return true;
    },
    openLotResolvePopup({ title, message, mode, options = [], inputPlaceholder = "" }) {
      return new Promise((resolve) => {
        this.lotResolveResolver = resolve;
        this.lotResolvePopup = {
          visible: true,
          title,
          message,
          mode,
          options,
          inputPlaceholder,
          confirmText: this.$t("common.save"),
          continueWithoutLotText: this.$t("stock_management.predefined_lot_numbers.save_without_lot_number"),
          cancelProcessText: this.$t("common.cancel"),
        };
      });
    },
    onLotResolvePopupResolved(payload) {
      const normalizedPayload = {
        action: payload?.action || "continue_without_lot",
        value: (payload?.value || "").trim(),
      };
      if (typeof this.lotResolveResolver === "function") {
        this.lotResolveResolver(normalizedPayload);
      }
      this.lotResolveResolver = null;
      this.lotResolvePopup.visible = false;
    },
    createErrormMssages() {
      let errorMessages = [];

      if (this.$v.fieldReportData.field_report_date.$invalid) {
        errorMessages.push("Data este obligatorie!");
      }

      if (this.fieldReportData.unloading_place == "") {
        errorMessages.push("Locul descărcării este obligatoriu!");
      }

      if (this.fieldReportData.uploading_place == "") {
        errorMessages.push("Locul încărcării este obligatoriu!");
      }

      if (this.fieldReportData.tractor_number_plate == "") {
        errorMessages.push("Numărul de înmatriculare al vehiculului este obligatoriu!");
      }

      if (this.fieldReportData.driver_name == "") {
        errorMessages.push("Numele sofer este obligatoriu!");
      }

      if (this.fieldReportData.driver_serial_identifier == "") {
        errorMessages.push("Seria sofer este obligatorie!");
      }

      if (this.fieldReportData.driver_number_identifier == "") {
        errorMessages.push("Numărul sofer este obligatoriu!");
      }

      return errorMessages;
    },
    /**
     * Builds the `weighing_products` array for a mobile field-report save.
     *
     * Two strategies are applied depending on whether the record being saved
     * was loaded from an existing multi-warehouse split:
     *
     * Strategy A — Multi-warehouse (loaded record with multiple distinct
     *   recipient_warehouse_uuid values in weighing_products):
     *   Parcels are grouped by legal entity (department_legal_entity_uuid).
     *   Each group's warehouse assignment is read from the existing
     *   weighing_products (parcel_uuid → recipient_warehouse_uuid mapping).
     *   Weight is distributed proportionally by parcel surface, first across
     *   groups then within each group — identical to the desktop
     *   buildProductDivisionFromWarehouseSplit logic.
     *
     * Strategy B — Single warehouse (new record or loaded record with one
     *   warehouse):
     *   Weight is distributed proportionally by parcel surface across all
     *   selected parcels using a single recipient_warehouse_uuid.
     *
     * @param {number} product_quantity_kg - Total quantity in kg to distribute.
     * @param {Object} product             - Product object from the selector.
     * @returns {Object[]} Array of weighing-product entries for the API payload.
     */
    calculateWeighingProducts(product_quantity_kg, product) {
      const contractUuid = this.selectedContracts.length > 0 ? this.selectedContracts[0].uuid : null;

      // Detect multi-warehouse split from loaded weighing_products.
      const recipientWarehouseUuids = extractRecipientWarehouseUuidsFromWeighingProducts(this.fieldReportData);

      if (recipientWarehouseUuids.length > 1) {
        // Strategy A: multi-warehouse — build parcel_uuid → warehouse_uuid map
        // from the existing weighing_products so no Vuex store lookup is needed.
        const parcelWarehouseMap = {};
        if (Array.isArray(this.fieldReportData.weighing_products)) {
          this.fieldReportData.weighing_products.forEach((wp) => {
            if (wp.parcel_uuid && wp.recipient_warehouse_uuid) {
              parcelWarehouseMap[wp.parcel_uuid] = wp.recipient_warehouse_uuid;
            }
          });
        }

        return buildWeighingProductsByWarehouseGroups({
          parcels: this.selectedLayers,
          parcelWarehouseMap,
          // Resolve legal-entity UUID the same way as the desktop wizard:
          // department_legal_entity_uuid → legal_entity.uuid → department_uuid.
          getLegalEntityUuid: (parcel) =>
            parcel.department_legal_entity_uuid ??
            parcel.legal_entity?.uuid ??
            parcel.department_uuid ??
            null,
          // In the mobile layer, the parcel UUID is stored as parcel.parcel_uuid.
          getParcelUuid: (parcel) => parcel.parcel_uuid,
          getSeasonOnParcelUuid: (parcel) => parcel.season_on_parcel_uuid,
          totalWeightKg: product_quantity_kg,
          decimals: this.quantityDecimalPlaces,
          product_uuid: product.uuid,
          product_name: product.name,
          product_code: product.code,
          measure_unit_id: product.measure_unit_id,
          product_type_uuid: product.product_type_uuid,
          unit_price: product.unit_price,
          // Warehouse routing is only in weighing_products, never flat on the record.
          issuer_warehouse_uuid: this.fieldReportData.issuer_warehouse_uuid ?? null,
          partner_uuid: this.fieldReportData.partner_uuid ?? null,
          contract_uuid: contractUuid,
        });
      }

      // Strategy B: single warehouse — proportional split across all parcels.
      const singleWarehouseUuid =
        recipientWarehouseUuids[0] ??
        this.fieldReportData.recipient_warehouse_uuid ??
        null;
      const divisions = divideWeightByParcels(
        this.selectedLayers,
        product_quantity_kg,
        this.quantityDecimalPlaces,
      );

      return this.selectedLayers.map((parcel, idx) => ({
        product_uuid: product.uuid,
        product_name: product.name,
        product_code: product.code,
        measure_unit_id: product.measure_unit_id,
        product_type_uuid: product.product_type_uuid,
        unit_price: product.unit_price,
        recipient_warehouse_uuid: singleWarehouseUuid,
        issuer_warehouse_uuid: this.fieldReportData.issuer_warehouse_uuid ?? null,
        partner_uuid: this.fieldReportData.partner_uuid ?? null,
        season_on_parcel_uuid: parcel.season_on_parcel_uuid,
        parcel_uuid: parcel.parcel_uuid,
        surface: parcel.surface,
        netto_weight_kg: divisions[idx],
        contract_uuid: contractUuid,
      }));
    },
    roundToDecimals(value, decimals) {
      return roundToDecimals(value, decimals);
    },
    goForward() {
      this.currentStep = this.currentStep + 1;
      this.setTitle();
    },
    showProductSelector() {
      this.productSelectorVisibility = true;
    },
    hideProductSelector() {
      this.productSelectorVisibility = false;
    },
    resetForm() {
      this.$v.$reset();
      this.fieldReportData = {
        products: [],
        field_report_date: moment().format(this.getDefaultDateFormat + " HH:mm"),
        unloading_place: "",
        uploading_place: "",
        contract_number: "",
        tractor_number_plate: "",
        driver_name: "",
        driver_serial_identifier: "",
        driver_number_identifier: "",
        custody: false, // Custodie
      };
      this.selectedLayers = [];
      this.selectedPartners = [];
      this.is_department_splited = false;
      this.layerDepartmentMap = [];
      this.selectedParcelSourceOption = null;
      this.parcelViewMode = "map";
      this.currentStep = 0;
      this.currentItem = 1;

      this.$refs["receptionInputScroll"].instance.scrollTo(0);

      if (this.$refs.googlemap) {
        this.$refs.googlemap.resetSelection();
        this.$refs.googlemap.refreshLayers();
      }
    },
    closeTransactions(message) {
      this.$emit("goBackParent", message);
    },
    showCalendarSelector() {
      this.is_date_selector_visible = !this.is_date_selector_visible; // disable temporary
    },
    calendarDayChosen(data) {
      this.is_date_selector_visible = false;
    },
    onDateSelected(date) {
      this.fieldReportData.field_report_date = date.selectedDate + " " + moment().format("HH:mm");
    },
    continueFromSelection() {
      this.currentStep = 0;
      this.setTitle();
    },
    setCurrentSeason(seasons) {
      if (seasons.length === 0) return;

      this.currentSeason = seasons[0];
      seasons.forEach((obj) => {
        if (new Date(obj.created_at) > new Date(this.currentSeason.created_at)) {
          this.$set(this, "currentSeason", obj);
        }
      });
      this.season_uuid_local = this.currentSeason.uuid;
    },
    onSeriesInput(e) {
      // Only allow letters (a-z, A-Z)
      const onlyLetters = e.event.target.value.replace(/[^a-zA-Z]/g, "");
      this.fieldReportData.driver_serial_identifier = onlyLetters;
      e.event.target.value = onlyLetters;
    },
    onNumberInput(e) {
      // Remove any non-digit characters
      const onlyNumbers = e.event.target.value.replace(/[^0-9.]/g, "");
      this.fieldReportData.driver_number_identifier = onlyNumbers;
      e.event.target.value = onlyNumbers;
    },
    findIdentifierByDriverName(name) {
      if (!name) return null;
      const relation = this.driverIdentifierRelation.find((r) => r.driver_name === name);
      if (relation) {
        return {
          serial: relation.driver_serial_identifier,
          number: relation.driver_number_identifier,
        };
      }
      return null;
    },
    onDriverNameSelected(e) {
      const driverName = e.value;
      const identifier = this.findIdentifierByDriverName(driverName);
      if (identifier) {
        this.fieldReportData.driver_serial_identifier = identifier.serial || "";
        this.fieldReportData.driver_number_identifier = identifier.number || "";
      }
    },
    /**
     * Clears the selected contract and all data derived from it (contract
     * number, custody flag, partner, and product lock).
     * Triggers the `selectedContracts` watcher which calls
     * `setDataBySelectedContract(undefined)` to reset the remaining fields.
     */
    clearContract() {
      this.selectedContracts = [];
      // Product editability is controlled by selectedContracts.length in the
      // template, so clearing the array is sufficient — no extra reset needed.
    },
    setDataBySelectedContract(selectedContract) {
      if (!selectedContract) {
        this.fieldReportData.contract_number = "";
        this.fieldReportData.custody = false;
        this.selectedPartners = [];
        return;
      }
      this.fieldReportData.contract_number = selectedContract.contract_number;
      if (selectedContract && selectedContract.contract_type_id == 3) {
        this.fieldReportData.custody = true;
      } else {
        this.fieldReportData.custody = false;
      }

      // Add partner to selectedPartners by selectedContract partner uuid
      if (selectedContract && selectedContract.partner_uuid) {
        this.getPartnerData({
          uuid: selectedContract.partner_uuid,
        }).then((response) => {
          if (response) {
            this.selectedPartners = [response];
          }
        });
      }

      // Set product based on selected contract
      if (selectedContract && selectedContract.product_uuid) {
        this.getProduct({
          uuid: selectedContract.product_uuid,
        }).then((response) => {
          if (response) {
            const product = {
              uuid: response.uuid,
              name: response.name,
              code: response.code,
              quantity: 0, // parseFloat(selectedContract.remaining_quantity) || 0,
              measure_unit_id: response.measure_unit_id,
              measure_unit: response.measure_unit,
              valid_measureunits_for_product: response.valid_measureunits_for_product || [],
              product_type_uuid: response.product_type_uuid || null,
              product_type: response.product_type || null,
            };
            this.fieldReportData.products = [product];
          }
        });
      }

      if (selectedContract && selectedContract.legal_entity_uuid) {
        this.selectedLayers = this.selectedLayers.filter(
          (layer) => (layer.department_legal_entity_uuid ?? layer.legal_entity?.uuid ?? null) === selectedContract.legal_entity_uuid,
        );
      }
    },
    mapSelectedParcelsFromReport(report) {
      return extractParcelsFromRecord(report);
    },
    /**
     * Extracts the product descriptor from a loaded weighing-on-scale record.
     *
     * `product_uuid`, `product_name`, `product_code`, `recipient_warehouse_uuid`,
     * and `issuer_warehouse_uuid` are read exclusively from
     * `record.weighing_products[0]` via the shared helper so that both
     * desktop and mobile reload use identical logic.
     *
     * Returns an empty array when no product data is available at all.
     *
     * @param {Object} report - API response data object.
     * @returns {Object[]} Zero or one product descriptor objects.
     */
    mapProductFromReport(report) {
      const extracted = extractProductFromWeighingProducts(report);

      // Return empty when truly nothing is available.
      if (!extracted.product_uuid && !extracted.product_name) {
        return [];
      }

      return [
        {
          uuid: extracted.product_uuid || "",
          name: extracted.product_name || "",
          code: extracted.product_code || "",
          lot_number: extracted.lot_number || "",
          quantity: extracted.quantity,
          unit_price: extracted.unit_price,
          notes: extracted.notes,
          measure_unit_id: extracted.measure_unit_id,
          measure_unit: extracted.measure_unit,
          product_type_uuid: extracted.product_type_uuid,
          product_type: extracted.product_type,
          valid_measureunits_for_product: extracted.valid_measureunits_for_product,
        },
      ];
    },
    async enrichProductMeasureUnits(product) {
      if (!product || !product.uuid || (Array.isArray(product.valid_measureunits_for_product) && product.valid_measureunits_for_product.length > 0)) {
        return product;
      }

      try {
        const response = await this.getProduct({ uuid: product.uuid });
        if (!response) {
          return product;
        }

        return {
          ...product,
          measure_unit_id: product.measure_unit_id || response.measure_unit_id || null,
          measure_unit: product.measure_unit || response.measure_unit || null,
          product_type_uuid: product.product_type_uuid || response.product_type_uuid || null,
          product_type: product.product_type || response.product_type || null,
          valid_measureunits_for_product: response.valid_measureunits_for_product || [],
        };
      } catch (e) {
        return product;
      }
    },
    async loadExistingFieldReport() {
      if (!this.selectedFieldReportUuid) {
        return;
      }

      this.loadingExistingReport = true;
      try {
        const response = await this.getWeighingOnScaleByUuid({ uuid: this.selectedFieldReportUuid });
        const report = response?.data || null;
        if (!report) {
          return;
        }

        const reportDateWithCurrentTime = report?.date
          ? moment(report.date).format(this.getDefaultDateFormat) + " " + moment().format("HH:mm")
          : this.fieldReportData.field_report_date;

        // Pull warehouse routing from weighing_products before spreading the
        // flat record — these fields only exist on weighing_products.
        const wpFields = extractProductFromWeighingProducts(report);
        // Collect all distinct recipient warehouse UUIDs from the full
        // weighing_products array so multi-warehouse splits are fully restored.
        const recipientWarehouseUuids = extractRecipientWarehouseUuidsFromWeighingProducts(report);

        this.fieldReportData = {
          ...this.fieldReportData,
          ...report,
          field_report_date: reportDateWithCurrentTime,
          products: this.mapProductFromReport(report),
          // Restore routing fields from weighing_products (authoritative source).
          // recipient_warehouse_uuid  = first (primary) warehouse.
          // recipient_warehouse_uuids = all distinct warehouses for multi-split.
          recipient_warehouse_uuid:  recipientWarehouseUuids[0] ?? wpFields.recipient_warehouse_uuid,
          recipient_warehouse_uuids: recipientWarehouseUuids.length > 0 ? recipientWarehouseUuids : [],
          issuer_warehouse_uuid: wpFields.issuer_warehouse_uuid,
        };

        if (this.fieldReportData.products.length > 0) {
          const enrichedProduct = await this.enrichProductMeasureUnits(this.fieldReportData.products[0]);
          this.fieldReportData.products = [enrichedProduct];
        }

        this.selectedLayers = this.mapSelectedParcelsFromReport(report).map((item) => ({ ...item }));

        /*if (report?.partner_uuid || report?.partner_name) {
          this.selectedPartners = [
            {
              uuid: report.partner_uuid || null,
              name: report.partner_name || "",
              locality: report.partner_locality || null,
              street_and_number: report.partner_address || "",
            },
          ];
        }*/

        if (report?.selectedContracts && Array.isArray(report.selectedContracts) && report.selectedContracts.length > 0) {
          this.selectedContracts = [
            {
              uuid: report.selectedContracts[0].uuid,
              contract_number: report.selectedContracts[0].contract_number,
              contract_type_id: report.selectedContracts[0].contract_type_id,
              legal_entity_uuid: report.selectedContracts[0].legal_entity_uuid,
              partner_uuid: report.selectedContracts[0].partner_uuid,
            },
          ];

          const selectedContract = this.selectedContracts[0];
          if (selectedContract && selectedContract.partner_uuid) {
            this.getPartnerData({
              uuid: selectedContract.partner_uuid,
            }).then((response) => {
              if (response) {
                this.selectedPartners = [response];
              }
            });
          }
        }

        this.fieldReportData.custody = Boolean(report?.custody);
        this.fieldReportData.contract_number = report?.contract_number || "";
        this.fieldReportData.unloading_place = report?.unloading_place || "";
        this.fieldReportData.uploading_place = report?.uploading_place || "";
        this.fieldReportData.tractor_number_plate = report?.tractor_number_plate || "";
        this.fieldReportData.driver_name = report?.driver_name || "";
        this.fieldReportData.driver_serial_identifier = report?.driver_serial_identifier || "";
        this.fieldReportData.driver_number_identifier = report?.driver_number_identifier || "";
      } finally {
        this.loadingExistingReport = false;
      }
    },
  },
  mounted() {
    this.fieldReportData.field_report_date = moment().format(this.getDefaultDateFormat + " HH:mm");
    this.getSeasons();
    this.setTitle();
    this.getDepartments({ limit: 1000 });

    this.getWeighingOnScaleAutocompleteData({
      history_types: [
        "driver_names",
        "tractor_number_plates",
        "driver_number_identifiers",
        "driver_serial_identifiers",
        "uploading_places",
        "unloading_places",
      ],
    }).then((response) => {
      if (response && response.data) {
        this.unloadingPlaceHistory = response.data.unloading_places || [];
        this.uploadPlaceHistory = response.data.uploading_places || [];
        this.driverSerialIdentifierHistory = response.data.driver_serial_identifiers || [];
        this.driverNumberIdentifierHistory = response.data.driver_number_identifiers || [];
        this.driverNameHistory = response.data.driver_names || [];
        this.tractorNumberPlateHistory = response.data.tractor_number_plates || [];
        this.driverIdentifierRelation = response.data.driver_identifier_relations || [];
      }
    });

    if (this.selectedFieldReportUuid) {
      this.loadExistingFieldReport();
    }
  },
  watch: {
    selectedFieldReportUuid(newVal) {
      if (newVal) {
        this.loadExistingFieldReport();
      }
    },
    seasons: {
      handler: function (newVal) {
        this.setCurrentSeason(newVal);
      },
    },
    selectedLayers: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          //season_on_parcel_uuid
          //parcel_uuid
          const departmentMap = {};
          newVal.forEach((layer) => {
            if (!departmentMap[layer.department_uuid]) {
              departmentMap[layer.department_uuid] = {
                uuid: layer.department_uuid,
                surface: 0,
              };
            }
            departmentMap[layer.department_uuid].surface += Number(layer.surface) || 0;
          });
          this.layerDepartmentMap = Object.values(departmentMap);
        }
      },
    },
    selectedContracts: {
      handler: function (newVal) {
        if (!this.loadingExistingReport) {
          this.setDataBySelectedContract(newVal[0]);
        }
      },
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/stockMobile/reception.scss";

.row-flex {
  display: flex;
  gap: 12px; /* optional, for spacing between fields */
}

.reception_input_holder .input_serie {
  width: 40%;
}

.reception_input_holder .input_number {
  width: 60%;
  margin-left: 0px !important;
}

.reception_input_holder .date_input_value {
  color: #7e7e7e !important;
}

.reception_input_holder .toggle-container p {
  margin-bottom: 0 !important;
}

.reception_contract_remove_icon {
  color: #e53935;
  font-size: 18px;
  padding: 0 6px;
}

.reception_contract_actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.step_1 {
  .step_1_container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 24px;
    margin-right: 24px;

    .step_title {
      text-align: center;
      margin-top: 30px;
      font-family: "Mulish";
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
      line-height: 24px;
      color: #3e3e3e;
    }

    .article_item {
      font-family: "Mulish";
      font-style: normal;
      font-weight: 700;
      font-size: 16px;
      line-height: 48px;
      letter-spacing: 0.02em;
      border: 1px solid #bebebe;
      box-sizing: border-box;
      border-radius: 100px;
      text-align: center;
      height: 48px;
      margin-top: 20px;
      width: 100%;
      color: #ea652a;
      background: #fff;
      cursor: pointer;
    }

    .article_item_selected {
      border: 1px solid #ea652a;
    }
  }
}

.field_report_parcel_list {
  height: 100%;
}
</style>
